import React from "react";
import styles from "./stepperHeader.module.scss";

const StepperHeader = ({ steps, activeStep }) => {
  return (
    <div className={styles.stepper}>
      {steps.map((s, i) => {
        const isActive = i === activeStep;
        const isDone = i < activeStep;
        const itemClass = [
          styles.stepperItem,
          isActive ? styles.activeItem : "",
          isDone ? styles.doneItem : "",
        ].join(" ").trim();

        const showConnector = i < steps.length - 1;

        return (
          <div className={itemClass} key={s.label}>
            <div className={styles.stepperTop}>
              <div className={styles.stepCircle}>{i + 1}</div>

              {showConnector && (
                <div className={styles.stepperLine}>
                  <div className={styles.stepperFill} />
                </div>
              )}
            </div>

            <div className={styles.stepperLabels}>
              <div className={styles.stepperLabel}>{s.label}</div>
              <div className={styles.stepperSub}>{s.sub}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StepperHeader;
